import DateOfBirthWrapper from 'features/reactivation/screens/DateOfBirth/DateOfBirthWrapper';
import React from 'react';

export default function ReactivationDobPage() {
  return <DateOfBirthWrapper />;
}
